import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpand = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.7375 14.375L10 8.65L4.2625 14.375L2.5 12.6125L10 5.1125L17.5 12.6125L15.7375 14.375Z",
		fill: "#004F87"
	})
});
export default SvgExpand;
